// Overlay block — front-end interaction
// Handles opening/closing .is-style-overlay panels via .is-style-overlay-modal-button links

const overlayFormButtons = document.querySelectorAll(
  ".is-style-overlay-modal-button > a",
);
if (overlayFormButtons.length) {
  overlayFormButtons.forEach(function (overlayFormButton) {
    overlayFormButton.addEventListener("click", toggleOverlayForm);
  });
}

/**
 * When position:fixed is inside an ancestor that has a CSS transform applied
 * (e.g. GSAP animations), the browser treats that ancestor as the containing
 * block instead of the viewport. We compensate by walking up the tree, finding
 * the first transformed ancestor, and applying inline offsets so the overlay
 * still covers the full viewport — without moving the element in the DOM.
 */
function applyViewportFix(overlayEl) {
  let ancestor = overlayEl.parentElement;
  while (ancestor && ancestor !== document.body) {
    const transform = window.getComputedStyle(ancestor).transform;
    if (transform && transform !== "none") {
      const rect = ancestor.getBoundingClientRect();
      // scaleX/scaleY account for any CSS scale on the ancestor
      const scaleX = ancestor.offsetWidth
        ? rect.width / ancestor.offsetWidth
        : 1;
      const scaleY = ancestor.offsetHeight
        ? rect.height / ancestor.offsetHeight
        : 1;
      overlayEl.style.top = `${-rect.top / scaleY}px`;
      overlayEl.style.left = `${-rect.left / scaleX}px`;
      overlayEl.style.width = `${window.innerWidth / scaleX}px`;
      overlayEl.style.height = `${window.innerHeight / scaleY}px`;
      return;
    }
    ancestor = ancestor.parentElement;
  }
  // No transformed ancestor — clear any previously applied fixes
  overlayEl.style.top =
    overlayEl.style.left =
    overlayEl.style.width =
    overlayEl.style.height =
      "";
}

function toggleOverlayForm(event) {
  event.preventDefault();
  const overlayForm = document.querySelector(this.getAttribute("href"));
  if (overlayForm) {
    document.querySelector("body").classList.toggle("body-overlay-active");
    overlayForm.classList.toggle("overlay-active");

    if (overlayForm.classList.contains("overlay-active")) {
      applyViewportFix(overlayForm);

      // Focus the first input when opening
      setTimeout(() => {
        const firstInput = overlayForm.querySelector("input");
        if (firstInput) firstInput.focus();
      }, 100);
    } else {
      // Reset any inline position fixes on close
      overlayForm.style.top =
        overlayForm.style.left =
        overlayForm.style.width =
        overlayForm.style.height =
          "";
    }

    // Create close button if it doesn't already exist
    if (!overlayForm.querySelector(".overlay-close-button")) {
      const closeButton = document.createElement("button");
      closeButton.classList.add("overlay-close-button");
      closeButton.innerHTML = '<span class="sr-only">Close Overlay</span>';
      closeButton.addEventListener("click", function () {
        overlayForm.classList.remove("overlay-active");
        document.querySelector("body").classList.remove("body-overlay-active");
        overlayForm.style.top =
          overlayForm.style.left =
          overlayForm.style.width =
          overlayForm.style.height =
            "";
        closeButton.remove();
      });
      overlayForm.querySelector(".wp-block-group").appendChild(closeButton);
    }
  } else {
    console.log(
      "Overlay element not found for href:",
      this.getAttribute("href"),
    );
  }
}
